export const datas = [
  {
    "id": "1",
    "characterName": "엄다오",
    "score": "40",
    "count": "213",
    "rankSumSum": "1.1"
  },
  {
    "id": "2",
    "characterName": "미지의",
    "score": "40",
    "count": "213",
    "rankSumSum": "1.1"
  },
  {
    "id": "3",
    "characterName": "1234Kcm",
    "score": "40",
    "count": "213",
    "rankSum": "1.1"
  },
  {
    "id": "4",
    "characterName": "1234Kcm",
    "score": "40",
    "count": "213",
    "rankSum": "1.1"
  },
  {
    "id": "5",
    "characterName": "신나는몰리 ",
    "score": "30",
    "count": "23",
    "rankSum": "1.3"
  },
  {
    "id": "6",
    "characterName": "덕히얏 ",
    "score": "25",
    "count": "212",
    "rankSum": "1.4"
  },
  {
    "id": "7",
    "characterName": "Racing프로 ",
    "score": "25",
    "count": "215",
    "rankSum": "1.8"
  },
  {
    "id": "8",
    "characterName": "까막훈  ",
    "score": "25",
    "count": "216",
    "rankSum": "2.6"
  },
  {
    "id": "9",
    "characterName": "그렇다며  ",
    "score": "25",
    "count": "218",
    "rankSum": "3.6"
  },
  {
    "id": "10",
    "characterName": "다오뇌파괴  ",
    "score": "25",
    "count": "243",
    "rankSum": "2.6"
  },
  {
    "id": "11",
    "characterName": "1234Kcm",
    "score": "5",
    "count": "213",
    "rankSum": "1.2"
  },
  {
    "id": "12",
    "characterName": "qooooxoooop ",
    "score": "21",
    "count": "258",
    "rankSum": "1.8"
  },
  {
    "id": "13",
    "characterName": "다오뇌파괴 ",
    "score": "15",
    "count": "212",
    "rankSum": "1.9"
  },
  {
    "id": "14",
    "characterName": "잠재고객 ",
    "score": "55",
    "count": "273",
    "rankSum": "1.7"
  },
  {
    "id": "15",
    "characterName": "장l무과금l인 ",
    "score": "18",
    "count": "212",
    "rankSum": "1.9"
  },
  {
    "id": "16",
    "characterName": "카러플재활중 ",
    "score": "30",
    "count": "219",
    "rankSum": "2.6"
  },
  {
    "id": "17",
    "characterName": "본벨 ",
    "score": "40",
    "count": "222",
    "rankSum": "2.6"
  },
  {
    "id": "18",
    "characterName": "verReverLiv ",
    "score": "10",
    "count": "233",
    "rankSum": "3.6"
  },
  {
    "id": "19",
    "characterName": "피렉스1대장 ",
    "score": "12",
    "count": "217",
    "rankSum": "3.2"
  },
  {
    "id": "20",
    "characterName": "미찌L ",
    "score": "13",
    "count": "218",
    "rankSum": "2.7"
  },
  {
    "id": "21",
    "characterName": "박인수",
    "score": "15",
    "count": "216",
    "rankSum": "2.2"
  },
  {
    "id": "22",
    "characterName": "강다훈 ",
    "score": "12",
    "count": "113",
    "rankSum": "3.1"
  },
  {
    "id": "23",
    "characterName": "노트북카트임 ",
    "score": "15",
    "count": "283",
    "rankSum": "2.6"
  },
  {
    "id": "24",
    "characterName": "아홉끝 ",
    "score": "25",
    "count": "217",
    "rankSum": "4.6"
  },
  {
    "id": "25",
    "characterName": "0l재명대통령 ",
    "score": "15",
    "count": "218",
    "rankSum": "4.8"
  },
  {
    "id": "26",
    "characterName": "BMT011GT ",
    "score": "11",
    "count": "211",
    "rankSum": "4.9"
  },
  {
    "id": "27",
    "characterName": "비활이 ",
    "score": "24",
    "count": "217",
    "rankSum": "4.8"
  },
  {
    "id": "28",
    "characterName": "스트로ng맨 ",
    "score": "16",
    "count": "218",
    "rankSum": "4.9"
  },

  {
    "id": "29",
    "characterName": "조창제송해요 ",
    "score": "19",
    "count": "222",
    "rankSum": "5.1"
  },
  {
    "id": "30",
    "characterName": "절벽통수승현 ",
    "score": "15",
    "count": "283",
    "rankSum": "5.6"
  },
  {
    "id": "31",
    "characterName": "안정환",
    "score": "45",
    "count": "201",
    "rankSum": "6.6"
  },
  {
    "id": "32",
    "characterName": "운탑 ",
    "score": "21",
    "count": "200",
    "rankSum": "6.6"
  },
  {
    "id": "33",
    "characterName": "노준현",
    "score": "19",
    "count": "203",
    "rankSum": "6.7"
  },
  {
    "id": "34",
    "characterName": "만약이 ",
    "score": "12",
    "count": "216",
    "rankSum": "7.6"
  },
  {
    "id": "35",
    "characterName": "합성시켰따 ",
    "score": "18",
    "count": "216",
    "rankSum": "11.6"
  },
  {
    "id": "36",
    "characterName": "1111xxxx ",
    "score": "21",
    "count": "216",
    "rankSum": "12.6"
  },
  {
    "id": "37",
    "characterName": "카트신태일임 ",
    "score": "25",
    "count": "214",
    "rankSum": "13.7"
  },
  {
    "id": "38",
    "characterName": "UnLimitDAO ",
    "score": "25",
    "count": "201",
    "rankSum": "15.7"
  },
  {
    "id": "39",
    "characterName": "현선일 ",
    "score": "14",
    "count": "217",
    "rankSum": "16.6"
  },
  {
    "id": "40",
    "characterName": "성장형파라곤 ",
    "score": "24",
    "count": "218",
    "rankSum": "17.2"
  },
  {
    "id": "41",
    "characterName": "BBEESSTT ",
    "score": "27",
    "count": "184",
    "rankSum": "18.4"
  },
  {
    "id": "42",
    "characterName": "뱍진우 ",
    "score": "25",
    "count": "174",
    "rankSum": "19.7"
  },
  {
    "id": "43",
    "characterName": "조이현귀여워 ",
    "score": "25",
    "count": "281",
    "rankSum": "20.6"
  },
  {
    "id": "45",
    "characterName": "모기면상 ",
    "score": "15",
    "count": "248",
    "rankSum": "21.6"
  },
  {
    "id": "46",
    "characterName": "신중한3학년",
    "score": "28",
    "count": "144",
    "rankSum": "22.6"
  },
  {
    "id": "47",
    "characterName": "Rivoceranib ",
    "score": "27",
    "count": "200",
    "rankSum": "22.9"
  }
]